export default "__VITE_ASSET__DJaaqR6u__"